export default {
  route: {
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    search: '搜索',
    add: '添加',
    skip: '转发',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    locking: '锁定',
    unlock: '解锁',
    disable: '禁用',
    enable: '启用',
    resetPassWord: '重置密码',
    toUpdate: '更新',
    save: '保存',
    cancel: '取 消',
    confirm: '确 定'
  },
  form: {
    add: '新增',
    operate: '操作'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js